import { useSelector } from 'react-redux'
import { ls } from 'utils/my-localstorage'
import { getSelectedCompany } from 'store/me'
import { ManagementRoles, Roles } from 'utils/consts/userRoles'
import type { RootState } from 'store'

export function useSelectedCompanyInfo() {
  const selectedCompany = useSelector(getSelectedCompany)
  const roleCode = useSelector(
    (state: RootState) =>
      state?.me?.data?.role?.code ?? ls.getItem('wwl-role_code') ?? Roles.PERSON
  )
  const isManagement = Object.values(ManagementRoles).includes(roleCode)
  const personName = useSelector(
    (state: RootState) => state?.me?.data?.username ?? ''
  )

  const getAdminData = () => ({
    name: personName,
    role: roleCode,
    visibleRole: roleCode,
  })
  const getCompanyData = () => ({
    name: selectedCompany?.tradeName,
    role: selectedCompany?.companyCategory?.masterName,
    visibleRole: selectedCompany?.companyCategory?.shortName,
  })
  const getPersonData = () => ({
    name: personName,
    role: roleCode,
    visibleRole: roleCode,
  })
  const { name, role, visibleRole } =
    (isManagement && getAdminData()) ||
    (selectedCompany && getCompanyData()) ||
    getPersonData()

  return { name, role, visibleRole, isManagement }
}
